import React from "react";
import { createRoot } from 'react-dom/client';
import '../../styles/components/store-locator.scss';
import { StoreLocatorSection } from "../react_components/StoreLocatorSection.js";
import { APIProvider } from '@vis.gl/react-google-maps';

const rootElements = Array.from(document.querySelectorAll('[data-store-locator-section-target]'));

// creates the roots to render the react components
if (rootElements.length > 0) {
  rootElements.forEach(rootEl => {
    const root = createRoot(rootEl);
    if (root) {
      root.render(
        <APIProvider apiKey={rootEl.dataset.storeLocatorSectionTarget}>
          <StoreLocatorSection />
        </APIProvider>
      );
      rootEl._reactRootContainer = root;
    }
    window.resizeTo(window.innerWidth, window.innerHeight);
  });
}
